import api from 'Plugins/api'
import InterNeedOrder from '../entities/interNeedOrder'

class InterNeedOrderInteractor {
  /**
   * 获取国际机票需求单列表
   */
  static async getInterNeedOrderList(query) {
    try {
      const { data = {} } = await api['tkQuery/tkNeedOrderList'](query)
      const list = data.list || []
      
      return {
        data: list.map(order => new InterNeedOrder(order))
      }
    } catch (error) {
      throw error
    }
  }
  
}

export default InterNeedOrderInteractor